<template>
  <SessionPageComp />
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import SessionPageComp from '../components/SessionPage.vue'
import { useAppStore } from '../composables/useAppStore'

const route = useRoute()
const { restoreSessionFromRoute } = useAppStore()

const props = defineProps<{ id?: string }>()

onMounted(() => {
  const sessionId = props.id || (route.params.id as string)
  if (sessionId) restoreSessionFromRoute(sessionId)
})

watch(() => route.params.id, (newId) => {
  if (newId && typeof newId === 'string') {
    restoreSessionFromRoute(newId)
  }
})
</script>
